export default __webpack_public_path__ + "static/plug-30ca38fc5aed9e8e702b9ba5d310f5e1.svg";